<script setup lang="ts">
/**
 * Application root.
 *
 * Two cross-cutting pieces live here rather than in the shell, because they must survive every
 * route including the login screen: the API-unreachable banner and the toast host (SPEC.md §10.4).
 */
import OfflineBanner from '@/shared/ui/OfflineBanner.vue'
import ToastHost from '@/shared/ui/ToastHost.vue'
</script>

<template>
  <div class="bg-surface-0 text-ink-900 flex min-h-screen flex-col">
    <OfflineBanner />
    <RouterView class="flex-1" />
    <ToastHost />
  </div>
</template>
